import {ReactNode} from 'react'
import {Button, ButtonProps} from 'react-bootstrap'

interface FormSubmitBtnProps extends ButtonProps {
  children?: ReactNode
}
function FormSubmitBtn({children, ...rest}: FormSubmitBtnProps) {
  return (
    <Button type="submit" {...rest}>
      {children || 'Submit'}
    </Button>
  )
}

export default FormSubmitBtn
